/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const legalEntityCurrencyRateLastService = {
  getList: (params: any) =>
    request.get('/legal-entity-currency-rate/last', { params })
};

export default legalEntityCurrencyRateLastService;
